const RadioFilter = ({ options, value, onChange }) => (
  <div className="filter p-1 bg-base-200 rounded-xl shrink-0">
    {options.map((f) => (
      <input
        key={f.key}
        type="radio"
        name="status-filter"
        aria-label={f.label}
        className="btn btn-sm rounded-lg hover:bg-transparent [&:checked]:!bg-neutral [&:checked]:!text-white [&:checked]:!border-neutral [&:checked]:hover:!bg-neutral"
        checked={value === f.key}
        onChange={() => onChange(f.key)}
      />
    ))}
  </div>
);

export default RadioFilter;
